import { post as $post, get as $get } from './core/fetch';
import config from './core/config';

export const manuel_predict = (predict) => $post('/manuel-predict', predict);
export const last_manuel_predict = (plant_id, class_id, class_design_id) => $get(`/last-manuel-predict/${plant_id}/${class_id}/${class_design_id}`);
export const get_daily_predict = (plant_id) => $get(`/get-daily-predicts/${plant_id}`);
export const run_predict = (predict) => $post(`${config.mlUrl}/run`, predict, { external: true });
export const manuel_predict_cost = (predict_id) => $get(`/manuel-predict-cost/${predict_id}`);
